import React from 'react'
import styled from 'styled-components'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import AppBar from '@mui/material/AppBar'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Button from '@mui/material/Button'
import Toolbar from '@mui/material/Toolbar'
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import Avatar from '@mui/material/Avatar'
import {ExitToApp, Phone, Person, Menu as MenuIcon, Language} from '@mui/icons-material'
import {LanguageContext} from 'containers/Intl'
import UserImage from 'components/UserImage'
import ModulesList from 'components/ModulesList'
import Dialog from 'components/Dialog'
import Icon from 'components/Icons'
import {fetchLogout} from 'modules/login/actions'
import {fetchModules} from 'modules/modules/actions'
import {fetchCallUsers} from 'modules/applications/actions'
import {getLanguages} from 'utils/utils'
import logo from './logo.svg'

const Flag = styled(Icon)`
    border-radius: 50%;
	margin-right: 10px;
`

const Logo = styled(Link)`
    height: 30px;
    width: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: left;
    background-image: ${props => props.logo ? `url('${props.logo}')` : `url('${logo}')`};
`

const Title = styled.div`
    font-family: HelveticaNeue;
    text-overflow: ellipsis;
    font-weight: 700;
    overflow: hidden;
    font-size: 16px;
    margin-right: auto;
`

const Globe = styled(Avatar)`
	margin-top: auto;
	align-self: flex-start;
`

const Bar = styled(AppBar)`
	color: #4a4a4a;
	background: white;
	box-shadow: 0 3px 5px 0 #cadce0;
	height: ${props => props.height ? props.height : 60}px;
`

const Tools = styled(Toolbar)`
	justify-content: flex-end;
	min-height: 50px;
	padding: 5px 10px;
`

class Header extends React.Component {
	static contextType = LanguageContext

    constructor(props) {
        super(props)

		this.languages = getLanguages()

        this.state = {
            anchorEl: null,
            drawer: false,
			chat: false,
			list: null
        }
    }

    componentDidMount() {
        this.props.fetchModules()
		this.props.fetchCallUsers()
    }

    changeLanguage = (e) => {
		this.closeSelect()
		this.context.setLang(e.currentTarget.id)
    }

    handleClick = (e) => {
        this.setState({anchorEl: e.target})
    }

    handleClose = () => {
        this.setState({anchorEl: null})
    }

    handleOpenMenu = () => {
        this.setState({
            drawer: true
        })
    }

    handleCloseMenu = () => {
        this.setState({
            drawer: false
        })
    }

	handleOpenDialog = () => {
		this.setState({
            chat: true
        })
	}

	handleCloseDialog = () => {
		this.setState({
            chat: false,
			anchorEl: null
        })
	}

	openSelect = (e) => {
        this.setState({list: e.target})
    }

    closeSelect = () => {
        this.setState({list: null})
    }

    render() {
        const {intl, image, module, logo} = this.props
        const currentModule = module ? this.props.modules.find(item => item.id === Number(module)) : null
		const lang = this.context.lang

        return (
            <React.Fragment>
                <Bar position="fixed" color="default"
                    height={this.props.height}
                >
                    <Tools>
                        <MenuIcon onClick={this.handleOpenMenu} style={{marginRight: 'auto', fontSize: '27px', cursor: 'pointer'}}/>
                        <Title>{this.props.children && this.props.children.length ? this.props.children[0] : this.props.children}</Title>
                        <UserImage type={image.type}
                            value={image.value}
                            size='small'
                            margin={'0 10px 0 20px'}
							onClick={this.handleClick}
                        />
                        <Menu
                            anchorEl={this.state.anchorEl}
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.handleClose}
                        >
                            <MenuItem onClick={this.props.fetchLogout} style={{ color: '#d45b4a'}}>
                                <ExitToApp sx={{marginRight: '10px'}} />
                                {intl.formatMessage({id: "header.logout"})}
                            </MenuItem>
							<MenuItem onClick={this.handleOpenDialog}>
                                <Phone sx={{marginRight: '10px'}} />
                                {intl.formatMessage({id: "header.chat"})}
                            </MenuItem>
                        </Menu>
                    </Tools>
                    {this.props.children && this.props.children.length ? this.props.children[1] : null}
                </Bar>
                <SwipeableDrawer
                    open={this.state.drawer}
                    onClose={this.handleCloseMenu}
                    onOpen={this.handleOpenMenu}
                    PaperProps={{
						sx: {
							padding: '15px',
							minWidth: '50%',
							boxSizing: 'border-box'
						}
					}}
                >
                    <Logo to={'/'} logo={logo} />
                    <ModulesList
                        modules={this.props.modules}
                        currentModule={currentModule}
                        mobile={true}
                        onClose={this.handleCloseMenu}
                        permissions={this.props.permissions}
                    />
					{this.languages.length &&
						<Globe onClick={this.openSelect}>
							<Language />
						</Globe>
					}
					<Menu
						anchorEl={this.state.list}
						open={!!this.state.list}
						onClose={this.closeSelect}
					>
						{this.languages.map((item, index) =>
							<MenuItem key={index} id={item.id} selected={item.id === lang} onClick={this.changeLanguage}>
								<Flag icon={item.id} width={25} height={25} />
								{item.name}
							</MenuItem>
						)}
					</Menu>
                </SwipeableDrawer>
				{this.state.chat &&
					<Dialog open fullWidth onClose={this.handleCloseDialog}>
						<DialogContent>
							<div>
								{this.props.users.map((item, index) =>
									<MenuItem onClick={this.handleCloseDialog}
										component='a'
										key={index}
										href={item.callUrl}
										target='_blank'
										disableGutters
									>
										<Person sx={{marginRight: '10px'}} />
										{item.name}
									</MenuItem>
								)}
							</div>
						</DialogContent>
						<DialogActions>
							<Button onClick={this.handleCloseDialog} color="primary">
								{intl.formatMessage({id: "app.confirm_close"})}
							</Button>
						</DialogActions>
					</Dialog>
				}

            </React.Fragment>
        )
    }
}

const mapStateToProps = ({login, modules, applications}) => ({
    image: login.logo,
    modules: modules.modules,
    permissions: login.permissions,
	users: applications.contacts
})

export default connect(mapStateToProps, {
    fetchLogout,
    fetchModules,
	fetchCallUsers
})(injectIntl(Header))
